module.exports = __webpack_public_path__ + "static/portfolio-klass-b2146e85122b509dfeaeeb278b8bc650.jpg";